__turbopack_context__.v({
  "date": "ShippingActivity-module__citsiG__date",
  "headerContainer": "ShippingActivity-module__citsiG__headerContainer",
  "orderedList": "ShippingActivity-module__citsiG__orderedList",
  "orderedlistItem": "ShippingActivity-module__citsiG__orderedlistItem",
  "shippingActivity": "ShippingActivity-module__citsiG__shippingActivity",
  "shippingActivityLandscape": "ShippingActivity-module__citsiG__shippingActivityLandscape",
});
